import { render, staticRenderFns } from "./LoginPageLayout.vue?vue&type=template&id=00c1b89b&"
import script from "./LoginPageLayout.vue?vue&type=script&lang=js&"
export * from "./LoginPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./LoginPageLayout.vue?vue&type=style&index=0&id=00c1b89b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports